import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import {framework} from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import {libs,ui} from 'saffroncodejs';
var PageManager = framework.PageManager ;

class PezeshkanKH extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isLoading:true,
            activeTab: 1,
            data:{"CodeMelli":"2142596347","BId":1358323,"FullBNo":"96/04/700/8055/4001559","SodurDate":"1396/02/30","LastBNo":null,"AgentText":"شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055","BimeGozarText":"علي ولائي کد 2599583 به نفع بانک صنعت و معدن  شعبه ساري","CodMelliOrEconomic":"2142596347","BimegozarAddress":"استان ‏مازندران‏،شهر آمل-شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي","BimegozarTel":"01222523538","BimeKindText":"صنعتي","ActivityKindText":"‏چراغ روشنايى خيابان ـ توليد‏","ActivitySharh":"توليد چراغ روشنايي گاز","AddressText":"استان ‏مازندران‏،شهر آمل ، شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي","Moddat":365,"BeginDate":"1396/03/01","EndDate":"1397/03/01","AllRiskText":" آتش سوزي ، صاعقه ، انفجار ، زلزله و آتشفشان ، سيل و طغيان آب ، طوفان و گردباد و تندباد ، ضايعات ذوب برف و آب باران ، ريزش سقف ناشي ازسنگيني برف ، تركيدگي لوله آب ، انفجار ظروف تحت فشار صنعتي ، دفرمه شدن ظروف تحت فشار","MarhunatSarmaye":1024000000,"MarhunatHbStr":"883,650 ريال","HBStr":"883,650 ريال","SumSarmayeStr":"1,024,000,000 ريال","SAAMPercent":"%9","MaliatAvarez":"79,529 ريال","HBWithAvarezStr":"963,179 ريال","Reshte":1,"Endorsement":[],"Mavared":[{"ShahrdariAvarezNerkh":3,"AfzoodeMaliatNerkh":6,"BId":1358323,"ElhNo":0,"GId":349,"MoredeBimeText":null,"MavaredTitr":"عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :","BNo":"96/04/700/8055/4001559","SodurText":"شعبه ساري کد 700","AgentText":"شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055","LastBNo":null,"PishnahadDate":"1396/02/16","SodurDate":"1396/02/30","SumSarmaye":1024000000,"SumSarmayeStr":"يك ميليارد و بيست و چهار ميليون","HB":883650,"HBText":"هشتصد و هشتاد و سه هزار و ششصد و پنجاه","MoneyUnitText":"ريال","Sharh":"ساختمان توليد ، اداري  با مساحت تقريبي 366  مترمربع  به  انضمام کليه تاسيسات مربوطه جمعا\" به ارزش","Sarmaye":"253,000,000","MaxCommitment":"253,000,000","Nerkh":"0.75","MHB":"126,500","Radif":"1","InnerOrder":1},{"ShahrdariAvarezNerkh":3,"AfzoodeMaliatNerkh":6,"BId":1358323,"ElhNo":0,"GId":349,"MoredeBimeText":null,"MavaredTitr":"عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :","BNo":"96/04/700/8055/4001559","SodurText":"شعبه ساري کد 700","AgentText":"شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055","LastBNo":null,"PishnahadDate":"1396/02/16","SodurDate":"1396/02/30","SumSarmaye":1024000000,"SumSarmayeStr":"يك ميليارد و بيست و چهار ميليون","HB":883650,"HBText":"هشتصد و هشتاد و سه هزار و ششصد و پنجاه","MoneyUnitText":"ريال","Sharh":"ماشين آلات  و تجهيزات طبق ليست پيوست نامه شماره 2148/م/الف بانک صنعت و معدن ساري جمعا\" به ارزش","Sarmaye":"771,000,000","MaxCommitment":"771,000,000","Nerkh":"0.9","MHB":"385,500","Radif":"2","InnerOrder":1}],"Bill":[],"PishnahadNo":null,"PishnahadDate":"1396/02/16","ElhNo":0,"ErrorMessage":null}
        }
        this.state.data = {} ;
        
        this.state.btns=[];
       
       this.loadDetail();
            
    }

    encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail()
    {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Ms/api/MsHV/HVInfo",
           
                {id: this.currentSodurId, codeMelli:  UserManager.MelliCode()}
                
            ),
            BimeManager.header())
            .then((result)=>{
                this.setState({data:result.data,isLoading:false});
                console.log('reciver: ', this.state.data)
            })
            .catch((error) => { alert(error) })   
    }

   
    render() {
        return (

            <div>
              <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>مسئولیت فنی پزشکان</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({activeTab:1}) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({activeTab:2}) }}>
                            دریافت کننده ها
                        </NavLink>
                    </NavItem>
                    
            
                </Nav>
               

{ (!this.state.isLoading)?(
        
         
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList RightToLeft">
                                    <Row>
                                        <Col sm="12"><span className="bold-head">شماره حواله:</span>{this.state.data.HvNo}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ حواله:</span>{this.state.data.HvDate}</Col>
                                        <Col sm="12"><span className="bold-head">شماره پرونده:</span>{this.state.data.PrvNo}</Col>
                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.FullBNo}</Col>
                                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{this.state.data.BId}</Col>
                                        <Col sm="12"><span className="bold-head">معرف:</span>{this.state.data.AgentText}</Col>
                                        <Col sm="12"><span className="bold-head">واحد صدور:</span>{this.state.data.SodurText}</Col>
                                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{this.state.data.BimeGozarText}</Col>
                                        <Col sm="12"><span className="bold-head">بابت خسارت:</span>{this.state.data.BabatText}</Col>
                                        <Col sm="12"><span className="bold-head">نوع حواله:</span>{this.state.data.HvKindText}</Col>
                                        <Col sm="12"><span className="bold-head">نوع خسارت:</span>{this.state.data.DamageKindText}</Col>
                                        <Col sm="12"><span className="bold-head">مبلغ حواله:</span>{libs.StringFunctions.currancyPrint(this.state.data.PayAmount)+('ریال')}</Col>
                        
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId={2}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                          (this.state.data.Recever)?  this.state.data.Recever.map((girande)=>{
                                                return <div className="border-List">
                                                            <Col sm="12"><span className="bold-head">نام گیرنده خسارت:</span>{girande.GirandeKindText}</Col>
                                                            <Col sm="12"><span className="bold-head">مبلغ قابل پرداخت:</span>{libs.StringFunctions.currancyPrint(girande.PayAmount)+('ریال')}</Col>
                                                           
                                                           
                                                           <br/>
                                                          </div>
                                            }):''
                                        }
                                            
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                       
                </TabContent>):(<ui.Preloader />)
                
            
            
         }
         </div>
        )
    }
}


export default PezeshkanKH;


// WEBPACK FOOTER //
// ./src/components/Khesarat/PezeshkanKH.js